<template>
  <div>
    <transition name="modal">
      <div class="modal-mask modal-mask-height">
        <div class="modal-wrapper">
          <div class="modal-dialog modal-sm">
            <div class="modal-content" style="padding:20px">
              <div class="modal-header text-center">
                <h4 class="modal-title">{{ msg }}</h4>
              </div>
              <div class="col-12 text-center mt-2">
                <button
                  id="show-modal"
                  type="button"
                  class="btn btn-danger  btn-sm trans-btn trans-btn-border col-sm-6 getFontBold"
                  @click="sendResponse"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: { msg: String },
  methods: {
    sendResponse() {
      this.$emit('response', false)
    },
  },
}
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header {
  border-bottom: none;
}

.getFontBold {
  font-family: JosefinSans-Bold;
  font-size: 14px;
}
</style>
